// src/Pages/Admin/Zones/ZonesPage.tsx
import React, { useState, useEffect } from "react";
import "../Event/AdminEvent.css"; // reuse existing styles
import ZoneForm from "./ZoneForm";
import { Zone } from "./types";
import HeroSectionV2 from "../../../components/HeroSectionV2";
import Billede1 from "../../../Images/Billede1.jpg"; // make sure this path is correct
import "../Event/AdminEvent.css"; // reuse styles
import AdminBackBar from "../../../components/admin/AdminBackBar";
import ZoneList from "./ZoneList";

const ZonesPage: React.FC = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [zones, setZones] = useState<Zone[]>([]);
    const [editingZone, setEditingZone] = useState<Zone | null>(null);
    const [showForm, setShowForm] = useState(false);

    // Fetch zones from backend
    const fetchZones = async () => {
        try {
            const res = await fetch(`${apiUrl}/api/zones`);
            if (!res.ok) throw new Error("Failed to fetch zones");
            const data: Zone[] = await res.json();
            setZones(data);
        } catch (err) {
            console.error(err);
            alert("Fejl ved hentning af zoner");
        }
    };

    useEffect(() => {
        fetchZones();
    }, []);

    // Save or update zone
    const handleSave = async (zone: Zone) => {
        try {
            if (zone.zoneID) {
                // Update
                const res = await fetch(`${apiUrl}/api/zones/${zone.zoneID}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(zone),
                });
                if (!res.ok) throw new Error("Fejl ved opdatering af zone");
            } else {
                // Create
                const res = await fetch(`${apiUrl}/api/zones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(zone),
                });
                if (!res.ok) throw new Error("Fejl ved oprettelse af zone");
            }

            setShowForm(false);
            setEditingZone(null);
            fetchZones(); // refresh list
        } catch (err) {
            console.error(err);
            alert("Fejl ved gemning af zone");
        }
    };

    // Edit
    const handleEdit = (zoneID: number) => {
        const zone = zones.find(z => z.zoneID === zoneID);
        if (zone) {
            setEditingZone(zone);
            setShowForm(true);
        }
    };

    // Delete
    const handleDelete = async (zoneID: number) => {
        if (window.confirm("Er du sikker p�, at du vil slette denne zone?")) {
            try {
                const res = await fetch(`${apiUrl}/api/zones/${zoneID}`, { method: "DELETE" });
                if (!res.ok) throw new Error("Fejl ved sletning af zone");
                fetchZones();
            } catch (err) {
                console.error(err);
                alert("Fejl ved sletning af zone");
            }
        }
    };

    return (
        <div>
            <HeroSectionV2
                titleEn="Zones"
                titleDa="Zoner"
                descriptionEn="Here you can create/edit/delete Zones"
                descriptionDa="Her kan du oprette/Redigere/Slette Zoner"
                imageSrc={Billede1}
            />
            <AdminBackBar
                title="Events"
                crumbs={[
                    { label: "Admin", to: "/admin" },
                    { label: "Events" } // current
                ]}
            />

            <div className="lists-grid">
                <div className="list-container">
                    <h2>Zoner</h2>
                    <button
                        className="add-btnnew"
                        onClick={() => { setShowForm(true); setEditingZone(null); }}
                    >
                        Opret Zone
                    </button>

                    {showForm && (
                        <ZoneForm
                            zone={editingZone}
                            onSave={handleSave}
                            onCancel={() => setShowForm(false)}
                        />
                    )}

                    <ZoneList
                        zones={zones}
                        onEdit={handleEdit}
                        onDelete={handleDelete} ></ZoneList>

                    
                </div>
            </div>
        </div>
    );
};

export default ZonesPage;